<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'ConfirmationOverlay',
    props: {
      isOpen: Boolean,
      object: Object,
    },
    data() {
      return {
        checkbox: false,
      }
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
    },
    methods: {
      onConfirmation() {
        this.$emit('onConfirmation')
      },
    },
  }
</script>
